import { render, staticRenderFns } from "./form-documents-mass-share.vue?vue&type=template&id=3f273249&scoped=true&lang=pug"
import script from "./form-documents-mass-share.vue?vue&type=script&lang=js"
export * from "./form-documents-mass-share.vue?vue&type=script&lang=js"
import style0 from "./form-documents-mass-share.vue?vue&type=style&index=0&id=3f273249&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f273249",
  null
  
)

export default component.exports